import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import BoltIcon from '@flipster/react/icon/generated/BoltIcon';
import { css } from '@flipster/styled-system/css';
import { hstack, vstack } from '@flipster/styled-system/patterns';
import { numberFormatter } from '@flipster/utils/num';

import { RewardImage } from '../_misc/RewardImage';
import { winnerAnnouncementBunja } from './bunja';

export interface WinnerAnnouncementProps {
  showGuideMessage?: boolean;
}

const WinnerAnnouncement = ({ showGuideMessage }: WinnerAnnouncementProps) => {
  const { rewardAtom, bidInfoAtom, imageUrlAtom } = useBunja(winnerAnnouncementBunja);
  const reward = useAtomValue(rewardAtom);
  const { highestBidder: winner, me } = useAtomValue(bidInfoAtom);
  const imageUrl = useAtomValue(imageUrlAtom);
  const winnerIsNotMe = winner && !winner.isMe;
  const showMyFinalBid = me.amount > 0 && winnerIsNotMe;
  if (!winner) return null;
  return (
    <div className={vstack({ w: '100%', gap: 8, textStyle: 'Text/M/Regular' })}>
      <p>
        <FormattedMessage id='Autogen_common.r251126.s_The_live_auction_is_over_Final_results_are_below' />
      </p>
      <div
        className={vstack({
          w: { base: '100%', tablet: 520 },
          gap: 16,
          p: { base: 16, tablet: 24 },
          borderRadius: 8,
          bg: 'background.default.level-3',
        })}
      >
        <p className={css({ textStyle: 'Title/XS', textAlign: 'center' })}>
          <FormattedMessage id='Autogen_common.r251126.s_Congratulations' />
          <br />
          <FormattedMessage id='Autogen_common.r251126.s_to_the_arg0_winner' values={{ arg0: reward }} />
        </p>
        <div className={vstack()}>
          <span className={hstack({ gap: 4, textStyle: 'Title/L' })}>
            <BoltIcon size={24} />
            <span>{numberFormatter(winner.amount)}</span>
          </span>
          <span className={css({ textStyle: 'Text/S/Strong' })}>{winner.nickname}</span>
        </div>
        <RewardImage imageUrl={imageUrl} />
        {showGuideMessage && (
          <p className={css({ color: 'content.default.level-2' })}>
            <FormattedMessage id='Autogen_common.r251126.s_Check_TnC_announcement_for_the_reward_timeline' />
          </p>
        )}
      </div>
      {showMyFinalBid && (
        <div
          className={vstack({
            w: { base: '100%', tablet: 520 },
            p: { base: 16, tablet: 24 },
            borderRadius: 8,
            bg: 'background.default.level-4',
          })}
        >
          <span className={css({ textStyle: 'Text/L/Strong' })}>
            <FormattedMessage id='Autogen_common.r251126.s_Your_final_bid' />
          </span>
          <span className={hstack({ mt: 8, gap: 4, textStyle: 'Title/L' })}>
            <BoltIcon size={16} />
            <span>{numberFormatter(me.amount)}</span>
          </span>
          <span className={css({ mt: 2, textStyle: 'Text/S/Strong' })}>{me.nickname}</span>
        </div>
      )}
    </div>
  );
};

export default WinnerAnnouncement;
